import { Outlet } from 'react-router-dom';

/**
 * Wraps the tenant-staff admin surface (`{tenant-domain}/admin` and
 * `app.auctisync.com/admin`). Activates `data-theme="admin"` so tokens
 * resolve to the admin surface palette.
 */
export function AdminLayout() {
  return (
    <div data-theme="admin" className="min-h-screen" style={{ background: 'var(--surface)' }}>
      <Outlet />
    </div>
  );
}
